<template>
  <div
    ref="alert"
    class="alert fade show d-flex align-items-center"
    :class="[`alert-${variant}`, {'alert-dismissible fade show': dismissible === true}]"
    role="alert"
  >
    <slot></slot>
    <button
      v-if="dismissible === true"
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      :aria-label="translate('Close')"
      @click="$emit('dismiss')"
    />
  </div>
</template>
<script lang="ts" setup>
import Alert from 'bootstrap/js/dist/alert.js';
import {type BootstrapAlertProps} from '@/components/shared/bootstrap/BootstrapAlert/BootstrapAlert.types';
const {variant = 'primary', dismissible = false} = defineProps<BootstrapAlertProps>();
defineEmits<{dismiss: []}>();
const {translate} = useLocalisation();
const element = useTemplateRef<HTMLDivElement>('alert');
onMounted(() => element.value !== null && new Alert(element.value));
</script>
<style lang="scss" scoped>
.alert {
  --bs-alert-border-color: transparent;
}
</style>
